import PropTypes from 'prop-types';
import SearchViewImpl from './search-view.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View for allowing data search input and result presentation.
 *
 * @class SearchView
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * SearchView prop types.
 *
 * @property {object} searchResult - Search result (error or found objects).
 * @property {Array<string>} recentItems - Recent items.
 * @property {string} [searchInputResetState = ''] - Random string, every time it changes, the search input will be reset..
 * @property {Mojito.Applications.Sports.Search.RecentSearch.itemCallback} [onRemoveRecentSearch = ()=>{}] - Remove recent search clicked callback.
 * @property {Function} [onSearchClose = ()=>{}] - On search close callback.
 * @property {Function} [onSportClick = ()=>{}] - On sport click callback.
 * @property {boolean} [initiallyActive = false] - Whether the component should be initially active.
 * @property {Array<Mojito.Presentation.Components.MenuRow.MenuRowItem>} [menuItems = []] - The sport menu items to be rendered.
 * @property {string} [selectedSport] - Selected sport.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchView
 */
const propTypes = {
    searchResult: PropTypes.object.isRequired,
    recentItems: PropTypes.arrayOf(PropTypes.string).isRequired,
    searchInputResetState: PropTypes.string,
    onRemoveRecentSearch: PropTypes.func,
    onSearchClose: PropTypes.func,
    initiallyActive: PropTypes.bool,
    onSportClick: PropTypes.func,
    menuItems: PropTypes.array,
    selectedSport: PropTypes.string,
};

const defaultProps = {
    menuItems: [],
    onRemoveRecentSearch: noop,
    onSearchClose: noop,
    onSportClick: noop,
    initiallyActive: false,
};

export default UIView('SearchView', SearchViewImpl, propTypes, defaultProps);
